export default __webpack_public_path__ + "static/media/vm-img2.0ff0cf6f.png";